import { render, staticRenderFns } from "./remarkEdit.vue?vue&type=template&id=748eec31&scoped=true"
import script from "./remarkEdit.vue?vue&type=script&lang=js"
export * from "./remarkEdit.vue?vue&type=script&lang=js"
import style0 from "./remarkEdit.vue?vue&type=style&index=0&id=748eec31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748eec31",
  null
  
)

export default component.exports